import React from "react";
// import PassengersField from "./PassengersFields";
import {
  Button,
  Checkbox,
  Dialog,
  Divider,
  InputAdornment,
  TextField,
} from "@material-ui/core";
import { useHistory } from "react-router";
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../../../../SearchPage/_redux/searchRedux";

import GetUserInformationField from "./GetUserInformationField";
import { useMediaQuery } from "react-responsive";
import fixNumbers from "../../../../../../functions/fixNumbers";
import { withStyles } from "@material-ui/styles";
import Confirmation from "./Confirmation"

const GetUserInformation = (props) => {
  let { state } = useSelector((state) => ({
    state: state.search,
  }));
  
  let { state: authState } = useSelector((state) => ({
    state: state.auth,
  }));

  const history = useHistory();
  const dispatch = useDispatch();
  const splittedURL = history.location.pathname.split("/");

  const [looped, setLooped] = React.useState([]);
  // const [looped2, setLooped2] = React.useState([]);
  const [btnStats, setBtnStats] = React.useState(true);
  const [open, setOpen] = React.useState(false);
  const [currentId, setCurrentId] = React.useState(null);
  const [dis, setDis] = React.useState("block");
  const [validates, setValidates] = React.useState({});
  const [isTotalValid, setIsTotalValid] = React.useState(false);
  const [checked, setChecked] = React.useState(false);
  const [otherSupervisor, setOtherSupervisor] = React.useState({phoneNumber:"",passenger:1});
  const [isFavEntered, setIsFavEntered] = React.useState(false);
  const validationHandler = () => {
    const keys = Object.keys(validates);
    keys.map((el) => {
      if (validates[el]) {
        setIsTotalValid(true);
      } else {
        setIsTotalValid(false);
      }
    });
  };

  const handleChange = (event) => {
    const name = event.target.name;
    setOtherSupervisor({
      ...otherSupervisor,
      [name]: event.target.value,
    });
    if(name == "passenger"){
      setOtherSupervisor({
        ...otherSupervisor,
        [name]: parseInt(event.target.value),
       })
    };
  };
  const useStyles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  }));
  const classes = useStyles()

  React.useEffect(() => {
    validationHandler();
  });

  
  React.useEffect(() => {
    dispatch(actions.setPhoneNumber(otherSupervisor))
  },[otherSupervisor]);

  React.useEffect(() => {
    if (
      looped.length === 0 &&
      state?.props?.count !== 0
    ) {
      passengersLooper();
    }
  },[state]);

  const passengersLooper = () => {
    const loopedArr = [];
    const  passengersNumber = state?.props?.count
    
    let count = null
    let sumCount = null
    if(passengersNumber){
      count =  passengersNumber?.split(",")
      sumCount = parseInt(count[0]) + parseInt(count[1])}   //  count[0]=adultCount ,  count[1]=childCount
    else{sumCount=parseInt(passengersNumber )}

    for (let i = 0; i < sumCount; i++) {
      let copiedValidates = validates;
      copiedValidates[i] = false;
      setValidates(copiedValidates);
      loopedArr.push({
        component: (
          <GetUserInformationField
            handleClickOpen={handleClickOpen}
            handleClose={handleClose}
            setBtnStats={setBtnStats}
            ValueIdSetter={ValueIdSetter}
            dis={dis}
            id={i}
            setValidates={setValidates}
            validates={validates}
            isFavEntered={isFavEntered}
          />
        ),
      });
    }

    setLooped(loopedArr);
  };

  const isMobile = useMediaQuery({ query: `(max-width: 760px)` });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const ValueIdSetter = (id) => {
    setCurrentId(id);
  };

  const FavPassengerValueHandler = (el) => {
    let copy = state.fullSeats;
    copy[currentId].passengerFirstName = el.passengerFirstName;
    copy[currentId].passengerLastName = el.passengerLastName;
    copy[currentId].passengerNationalCode = fixNumbers(
      el.passengerNationalCode
    );
    copy[currentId].gender = el.passengerGender;

    dispatch(actions.setFullSeats(copy));
    handleClose();
    setIsFavEntered(true);
    setTimeout(() => {
      setIsFavEntered(false);
    });
  };

  const CssTextField = withStyles({
    root: {
      "& label.Mui-focused": {
        color: "#d9d9d9d",
      },
      "& .MuiInput-underline:after": {
        borderBottomColor: "#d9d9d9d",
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: "#6dd06d",
        },
        "&:hover fieldset": {
          borderColor: "#6dd06d",
        },
        "&.Mui-focused fieldset": {
          borderColor: "#d9d9d9d",
        },
      },
    },
  })(TextField);

  
  let sumCount = parseInt(state?.props?.count?.split(",")[0]) + parseInt(state?.props?.count?.split(",")[1])

  return (
    <>
        <div
        className="d-flex flex-column bg-white  shadow-sm my-1 p-7 container"
        style={{ border: "1px solid darkgray", borderRadius: 13 }}
        >
        <div className="my-2">
            <h3 className="mt-1 mb-5">
            <b>اطلاعات مسافران</b>
            </h3>
            <h6>
            ابتدا صندلی های موردنظر خود را انتخاب کرده، سپس اطلاعات هر یک از مسافران را در کادرهای زیر وارد نمایید.
            </h6>
        </div>
        <div className="my-1" style={{ display: `${dis}` }}>
            {looped.length !== 0
            ? looped.map((el) => {
                return el.component;
                })
            : null}
        </div>
        <div
            className="d-flex flex-column"
            style={{ gap: "15px", marginBlock: "0px 30px" }}
        >
            <Divider className="w-100" />
            <div className="row" style={{ alignItems: "flex-end" }}>
            <Checkbox
                checked={checked}
                onChange={(e) => setChecked(!checked)}
                style={{ color: "black" }}
            />
            <h5>
                <b>آیا میخواهید اطلاعات بلیط برای فرد دیگری ارسال شود؟</b>
            </h5>
            </div>
            {checked ? (
            <div className="row">
                <h6 style={{ lineHeight: "25px" }} className="col-12">
                در صورتی که تمایل دارید اطلاعات بلیط به شخص دیگری ارسال
                شود شماره آن را در کادر زیر وارد نمایید:
                </h6>
                <div className="row col-12 col-md-5 ml-5">
                <div >
                    <TextField
                    className="mx-auto my-2"
                    fullWidth
                    variant="outlined"
                    type="number"
                    placeholder="مثال:09101234567"
                    name="phoneNumber"
                    onChange={(e) => {
                        handleChange(e)
                    }}
                    />
                </div>
                </div>
                <div className="row col-12 col-md-7 d-flex align-items-center" >
                  <p style={{fontSize:"1.115rem"}} className="pl-5 pl-md-0 mb-0 d-flex align-items-center mr-5">
                  این شماره تلفن متعلق به کدام مسافر می باشد:
                  </p>
                  <FormControl variant="outlined" className={`col-8 col-md-3 ml-10 ml-md-0 ${classes.formControl}`}>
                    <InputLabel htmlFor="outlined-passenger-native-simple">مسافر</InputLabel>
                    <Select
                      name="passenger"
                      style={{ borderRadius: "13px", cursor: 'pointer' }}
                      native
                      onChange={(e) => {
                        handleChange(e)
                      }}
                      label="مسافر"
                      inputProps={{
                        name: 'passenger',
                        id: 'outlined-passenger-native-simple',
                      }}
                    >
                      {/* <option aria-label="None" value="" /> */}
                      {(() => {
                        let rows = [];
                        for (let i = 0; i < sumCount; i++) {
                          rows.push(<option value={i+1} style={{ cursor: 'pointer' }} > مسافر صندلی {state.fullSeats[i]?.seatNumber}</option>);
                        }
                        return rows;
                      })()}
                    </Select>
                    {/* {touched.passenger? (
                      <b className="text-danger">
                        {errors.passenger}
                      </b>
                    ) : null} */}
                  </FormControl>
                </div>
            </div>
            ) : null}
        </div>
        <Dialog
            open={open}
            keepMounted
            onClose={handleClose}
            PaperProps={{
            style: {
                minWidth: isMobile ? "80%" : "40%",
                height: "auto",
                width: "auto",
            },
            }}
            aria-describedby="alert-dialog-slide-description"
        >
            <div style={{ padding: 30 }}>
            <h2 className="mb-14">
                <b>مسافرین منتخب</b>
            </h2>
            {state.favPassengers.length !== 0
                ? state.favPassengers.map((el) => {
                    return (
                    <div className="d-flex flex-wrap my-2 container justify-content-between">
                        <h4>{` ${el.passengerFirstName} ${el.passengerLastName}`}</h4>
                        <Button
                        className="btn"
                        style={{
                            backgroundColor: "#6dd06d",
                            height: 30,
                        }}
                        onClick={() => {
                            FavPassengerValueHandler(el);
                        }}
                        >
                        <h6 className="text-white my-auto">
                            <b> انتخاب</b>
                        </h6>
                        </Button>
                    </div>
                    );
                })
                : " تاکنون بلیطی خریداری نکرده اید."}
            </div>
        </Dialog>

        </div>
        <Confirmation step={props.step} handleComplete={props.handleComplete} isTotalValid={isTotalValid}/>
    </>
  );
};

export default GetUserInformation;
